import React, { useState, useEffect, useMemo } from 'react'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography, Stack, Pagination, PaginationItem, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { MuiFileInput } from 'mui-file-input'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import excel_img from '../../../asset/excel_img.png'

import TablePagination from '@mui/material/TablePagination'

import { MantineReactTable, useMantineReactTable } from 'mantine-react-table'

const rows = []

const MyPagination = styled(Pagination)({
  '& .Mui-selected': {
    border: '1px solid',
    borderImageSource:
      'linear-gradient(166.93deg, #AFAFAF 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 67.95%)',
    backgroundColor:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 5.98%, rgba(0, 0, 0, 0) 66.28%)',
    color: '#ffffff',
  },
  '& .MuiPaginationItem-root': {
    color: '#ffffff',
  },
  //There has a lot of Global classes. you have to use it according to your requirement
  //Some classes are MuiPaginationItem-root, MuiPaginationItem-page and Mui-selected
})

const styles1 = {
  grid1: {
    padding: 4,
    background: '#2C2D33',
    borderRadius: '10px',
    border: '1px solid #afafaf',
    borderImageSlice: 1,
    borderImage:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'center',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography2: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '17px',
    fontWeight: 700,
    lineHeight: '21.72px',
    textAlign: 'center',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography3: {
    color: '#807F88',
    fontFamily: 'Noto Sans KR',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '18.82px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  fileSelect1: {
    '& .MuiInputBase-root': {
      backgroundColor: '#ffffff',
      color: '#000000',
      borderRadius: '0px 5px 5px 0px',
    },
  },
  TableCell1: {
    color: '#CCCCCC',
    borderBottom: '1px solid #CCCCCC',
    background:
      'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
  },

  TableCellHeader1: { background: '#2F2E41', color: '#ffffff', borderBottom: '1px solid #CCCCCC' },
}

const StyledTab = styled(Tab)(({ theme }) => ({
  color: '#807F88',
  fontFamily: 'Noto Sans KR',
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '28.96px',
  textAlign: 'left',
  textUnderlinePosition: 'from-font',
  textDecorationSkipInk: 'none',

  '&.Mui-selected': {
    fontWeight: 700,
    color: '#FFFFFF',
    borderBottom: '7px solid',
    // border색깔 시작
    borderImage: 'linear-gradient(89.58deg, #2C5B5F 10%, #AFAFAF 99.08%)',
    borderImageSlice: 1,
    // border색깔 끝
  },
  '&:hover': {
    fontWeight: 700,
    color: '#FFFFFF',
  },
}))

export default function OTA() {
  const [currentPage, setCurrentPage] = React.useState(1)

  const onPageChange = (e, page) => {
    setCurrentPage(page)
  }

  const [pg, setpg] = React.useState(0)
  const [rpg, setrpg] = React.useState(5)
  const [fileList, setFileList] = useState([])

  const columns = useMemo(
    () => [
      {
        accessorKey: 'grp_name',
        header: '파일명',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'grp_type',
        header: '용도',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'lon',
        header: '크기',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'mid_count',
        header: '업로드시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )

  const table = useMantineReactTable({
    columns: columns,
    data: fileList, //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    getRowId: (row) => row.ji,
    // onRowSelectionChange: setRowSelection,
    // state: { rowSelection },
    // selectDisplayMode: 'checkbox',
    // enableRowSelection: true,
    // enableMultiRowSelection: true,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: true,
    enableSorting: false,
    enableFullScreenToggle: false,
    paginationDisplayMode: 'pages',
    initialState: { density: 'sm' },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: (event) => {
    //     handleModifyGroupFlagFalse()
    //     setRowDetail(row.original)
    //   },
    //   sx: {
    //     cursor: 'pointer', //you might want to change the cursor too when adding an onClick
    //   },
    // }),
    mantineTableHeadCellProps: {
      sx: { background: '#2F2E41' },
      align: 'center',
      // '.mantine-TableHeadCell-Content-Wrapper': {
      //   color: '#ffffff',
      // },
      ' .mantine-TableHeadCell-Content-Labels .mantine-TableHeadCell-Content-Wrapper': {
        color: '#ffffff',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        color: '#CCCCCC',
        background:
          'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
      align: 'center',
    },
    mantineDetailPanelProps: {
      sx: {
        color: '#ffffff',
        background:
          'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
    },
    mantineTopToolbarProps: {
      sx: {
        color: '#ffffff',
        background: '#21222D',
        // mantine-Stack-root
        '.mantine-Alert-root': {
          color: '#ffffff',
          background: '#21222D',
        },
        '.mantine-Stack-root': {
          color: '#ffffff',
          background: '#21222D',
        },
      },
    },
    mantineBottomToolbarProps: {
      sx: {
        background: '#21222D',
        '.mantine-Input-input': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '.mantine-InputWrapper-label': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '& .mantine-Text-root': {
          color: '#ffffff',
        },
      },
    },
    mantinePaginationProps: {
      sx: {
        background: '#21222D',
        '.mantine-UnstyledButton-root': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
      },
    },
  })

  function handleChangePage(event, newpage) {
    setpg(newpage)
  }
  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10))
    setpg(0)
  }

  const [value, setValue] = React.useState('1')
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const [file, setFile] = React.useState([])
  const handleFile = (newValue) => {
    setFile(newValue)
  }

  // const Upload_file = async (e) => {
  //   e.preventDefault()
  //   const formData = new FormData()
  //   formData.append('update_file', file)

  //   let Object = {
  //     aeVersion: aeVersion,
  //     file: formData,
  //     aeType: aeType,
  //   }
  //   try {
  //     const response = await Api.post('m2m/upload', Object, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //       withCredentials: true,
  //     })
  //     if (response.status === 200) {
  //       // console.log("response.data : ", response.data);
  //       // setAeType('')
  //       // setAeVersion('')
  //       // setFile('')
  //       // alert('파일 업로드 성공')
  //     }
  //     if (response.status === 401) {
  //       // console.log("response.data : ", response.data);
  //       alert('파일 업로드 실패.')
  //     }
  //   } catch (e) {
  //     alert('파일 업로드 에러')
  //     // console.log(e.response.status);
  //   }
  // }
  return (
    <div>
      <Grid container>
        <Grid size={12} sx={styles1.grid1}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <Typography sx={styles1.Typography1}>OTA 파일업로드</Typography>
            </Grid>
            <Grid size={6} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center',paddingLeft:10 }}>
              <Stack direction="row" >
                <Box
                  sx={{
                    background: '#2A2E82',
                    width: 115,
                    height: 56,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '5px 0px 0px 5px',
                  }}
                >
                  <Typography sx={styles1.Typography2}>파일선택</Typography>
                </Box>
              </Stack>
              <MuiFileInput sx={[styles1.fileSelect1, { display: 'flex', width: '100%' }]} value={file} onChange={handleFile} />
            </Grid>
            <Grid size={6} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', paddingRight:10 }}>
              <Stack
                direction="row"
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                <Box
                  sx={{
                    background: '#2A2E82',
                    width: 115,
                    height: 56,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '5px 0px 0px 5px',
                  }}
                >
                  <Typography sx={styles1.Typography2}>용도</Typography>
                </Box>
              </Stack>
              <TextField sx={[styles1.fileSelect1, { display: 'flex', width: '100%' }]}></TextField>
            </Grid>
            <Grid size={6} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 4 }}>
              <Button
                variant="contained"
                sx={{
                  background: 'linear-gradient(180deg, #4A51D5 0%, #2A2E82 98.5%)',
                }}
              >
                파일업로드
              </Button>
            </Grid>
            <Grid size={6} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: 4 }}>
              <Button variant="contained" sx={{ width: 104, height: 36.5, background: '#807F88' }}>
                취소
              </Button>
            </Grid>
            <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Stack>
                <Typography sx={styles1.Typography3}>
                  파일확장자는 .zip 이어야하며 용량은 50MB 초과하지 않아야 합니다.{' '}
                </Typography>
                <Typography sx={styles1.Typography3}>
                  전송이 완료되지 않은 상태에서 창을 닫으면 파일이 업로드 되지 않습니다.
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={12} sx={{ marginTop: 3 }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList
                sx={{ marginLeft: 3 }}
                TabIndicatorProps={{
                  style: {
                    display: 'none',
                  },
                }}
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <StyledTab label="업로드 파일리스트" value="1" />
                <StyledTab label="OTA 통신 기록" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <Grid container>
                <Grid size={12}>
                  <Typography sx={[styles1.Typography1, { marginBottom: 2 }]}>업로드 파일리스트</Typography>
                </Grid>
                <Grid
                  size={12}
                  sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 1 }}
                >
                  <Button variant="contained" sx={{ color: '#ffffff', background: '#454546' }}>
                    <img style={{ width: 25, height: 25 }} src={excel_img}></img>&nbsp;엑셀 내보내기
                  </Button>
                </Grid>
                <Grid size={12} sx={{ marginTop: 1 }}>
                  <Paper>
                    <MantineReactTable table={table} />
                  </Paper>
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value="2">
              <Grid container>
                <Grid size={12}>
                  <Typography sx={[styles1.Typography1, { marginBottom: 2 }]}>OTA 통신 기록</Typography>
                </Grid>
                <Grid
                  size={12}
                  sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 1 }}
                >
                  <Button variant="contained" sx={{ color: '#ffffff', background: '#454546' }}>
                    <img style={{ width: 25, height: 25 }} src={excel_img}></img>&nbsp;엑셀 내보내기
                  </Button>
                </Grid>
                <Grid size={12} sx={{ marginTop: 1 }}>
                  <Paper>
                    <MantineReactTable table={table} />
                  </Paper>
                </Grid>
              </Grid>
            </TabPanel>
          </TabContext>
        </Grid>
      </Grid>
    </div>
  )
}
